import http from './http.service';

class NomenclatureService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/nomenclatures";
    }

    getParentBySort(sort) {
        if (!sort) {
            throw new Error('Sort is required');
        }

        return this.$http.get(`${this.baseUrl}/getParentBySort/${sort}`);
    };

    getParentByName(name) {
        if (!name) {
            throw new Error('Parent name is required');
        }

        const nameEncoded = btoa(unescape(encodeURIComponent(name)));
        return this.$http.get(`${this.baseUrl}/getParentByName`, { params: { nameEncoded } });
    };

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/create`, model);
    };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/update`, model);
    };

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activate`, { params: { id: id } });
    }

    deactivate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivate`, { params: { id: id } });
    }

    massEdit(model) {
        return this.$http.post(`${this.baseUrl}/massEdit`, model);
    }
}

export default new NomenclatureService();
